<template>
    <router-view />
</template>
<script>
export default {
    name: "clients"
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/index.vue